import { Button, Space } from "antd";
import { ReactNode } from "react";
import InfoIcon from "../assets/icons/InfoIcon";
import LockIcon2 from "../assets/icons/LockIcon2";
import CustomModal from "../components/ui/CustomModal";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: DataT;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  handleButton: (val?: any) => void;
  loading?: boolean;
  children?: ReactNode;
}

export default function ConfirmModalLayout({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,
  handleButton,
  handleClose,
  children,
  type,
  data,
  loading,
  ...rest
}: ModalConfirmProps) {
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <div className="flex items-center gap-2">
          <span className="bg-[#FFF6ED] p-1 rounded">
            {action ? <InfoIcon /> : <LockIcon2 />}
          </span>
          <span className="text-[22px] font-semibold">{title}</span>
        </div>
        <div className="my-2 mt-3 text-[#5E718D]">{subTitle}</div>
        {children}
        <Space className="w-full mt-3" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            onClick={handleButton}
            loading={loading}
          >
            {buttonName}
          </Button>
        </Space>
      </CustomModal>
    </>
  );
}
